import type { JSX, ReactNode } from 'react';
import { CalendarClock } from 'lucide-react';

interface PredictionEmptyStateProps {
  title: string;
  description: ReactNode;
  /** The API's own message, shown smaller as the reason. */
  detail?: string | null;
  icon?: ReactNode;
  action?: ReactNode;
}

/** Compact card shown in place of a prediction that isn't available. */
export default function PredictionEmptyState({
  title,
  description,
  detail,
  icon = <CalendarClock size={22} />,
  action,
}: PredictionEmptyStateProps): JSX.Element {
  return (
    <div
      role="status"
      className="mx-auto mt-6 flex w-full max-w-xl flex-col items-center gap-3 rounded-xl border border-[#2DAAFD]/40 bg-gradient-to-br from-[#F8FBFF] to-[#E6F3FF] px-6 py-7 text-center"
    >
      <span className="flex h-12 w-12 items-center justify-center rounded-full bg-[linear-gradient(to_right,#082261,#34065c)] text-white shadow-md">
        {icon}
      </span>
      <h3 className="font-spectral text-lg font-semibold text-[#001B6B]">{title}</h3>
      <p className="max-w-md font-lato text-[15px] leading-relaxed text-[#333333]">
        {description}
      </p>
      {detail && (
        <p className="rounded-full bg-white px-3 py-1 font-lato text-xs text-gray-500 shadow-sm">
          Reason: {detail}
        </p>
      )}
      {action}
    </div>
  );
}
